import React from "react";
import withHotKeys from "./hotkeys";
import Editor from "./editor";
import Master from "./master";
import { observable, action } from "mobx";
import { observer } from "mobx-react";
import startLive from "../scheduler/index";

import "./layout.css";

export var state = observable({
  isPreview: false
});

export const startPreview = action("showPreview", () => {
  state.isPreview = true;
  startLive();
});
export const stopPreview = action("hidePreview", () => (state.isPreview = false));

export default withHotKeys(
  observer(p => {
    return p.live || state.isPreview ? <Master live={p.live} /> : <Editor />;
  })
);



// WEBPACK FOOTER //
// ./src/layout/index.js